export const getErrorDescription = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get('error_description') || '';
};
